import action from './action'

export default {
    getProviders() {
        return action.request('get_welcom_providers',{})
    }
}
